module.exports = __webpack_public_path__ + "static/image_15_thumb-bb22e8899edf251a4c5e538411c051e9.jpg";